var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCashflow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 34,
    viewBox: "0 0 34 34",
    width: 34,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-7 -7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h48v48h-48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h48v48h-48z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.94599997 16.35c4.22362003-7.76179995 13.93974003-10.63007995 21.70160003-6.40643995 5.1488 2.80173995 8.35334 8.19471995 8.3524402 14.05643995"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24 19.092v-1.092"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24 28.91v1.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.158 27.74c.420324.720716 1.189692 1.16622 2.024 1.172h1.8-.0000001c1.269148-.0026771 2.29582-1.033694 2.2931453-2.30284-.0022213-1.050556-.7165933-1.965846-1.7351533-2.22316l-3.068-.77h-.0000002c-1.23049-.306322-1.979678-1.552154-1.673356-2.78264.254836-1.023674 1.174438-1.741978 2.22936-1.7413564h1.8.0000002c.831782.0054529 1.598938.4494744 2.018 1.1680004"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.99999981 24v.0024438c0 8.83656 7.16343999 16 15.99999999 16 5.86174 0 11.25422-3.20536 14.05518-8.3546"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.094 16.35h-7.07v-7.072"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.906 31.65h7.07v7.072"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashflow);
export default __webpack_public_path__ + "static/media/cashflow.832732cec0f8597533b02336f010f896.svg";
export { ForwardRef as ReactComponent };